export default "__VITE_ASSET__5c31dec4__"